import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { resolveValueDisplay } from '@app/hcs-shared';
import { ModuleFE_Value } from './ModuleFE_Value.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_Value,
    modules: [ModuleFE_Value],
    mapper: item => [resolveValueDisplay(item)],
    placeholder: 'Choose a Value',
    renderer: item => _jsx(_Fragment, { children: resolveValueDisplay(item) })
};
export const DropDown_Value = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Value,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), resolveValueDisplay(item)] });
    },
    uiSelector: DropDown_Value.selectable,
});
export const MultiSelect_Value = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map